import type { ClientValue, ContactValue } from './CreateCallClientContactSelect';
export { default } from './CreateCallClientContactSelect';
export type { ClientValue, ContactValue };
